import { Box, ThemeProvider } from "@mui/material";
import { useTheme } from "@mui/material";

const About: React.FC = () => {
  const theme = useTheme();
  return (
    
    <ThemeProvider theme={theme}>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          justifyContent: "left",
          alignItems: "left",
          background: theme.palette.background.default
        }}
      >
      </Box>
      <Box sx={{
        background: theme.palette.background.default,
        width: "100%",
        display: "flex",
        justifyContent: "center"
      }}>
    
      </Box>
      <Box
        sx={{
          width: "100%",
          display: "grid",
          justifyContent: "left",
          alignItems: "left",
          
          background: theme.palette.background.default
        }}
      >
      </Box>
    </ThemeProvider>
  );
};

export default About;
